'use client';

const getNoun = (amount) => amount === 1 ? "character" : "characters";
const allowedCharsLabel = (amount) => `${amount} ${getNoun(amount)} allowed`;
const charsLeftLabel = (amount) => `${amount} ${getNoun(amount)} left`;
export {
  allowedCharsLabel,
  charsLeftLabel
};
